import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import "./ExitButton.css";
import SvgIcon from '../SvgIcon';
import svgCloseIcon from "../../../../svg-icons/nx-close.svg";

var ModalExitButton = function ModalExitButton(_a) {
  var onClick = _a.onClick,
      className = _a.className;
  return React.createElement(SvgIcon, {
    className: cx('nx-modals-exit-button', className),
    onClick: onClick,
    hoverColor: "#666",
    color: "#ccc",
    src: svgCloseIcon
  });
};

ModalExitButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string
};
export default ModalExitButton;

try {
  // @ts-ignore
  ExitButton.__docgenInfo = {
    "description": "",
    "displayName": "ExitButton",
    "props": {
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "onClick": {
        "defaultValue": null,
        "description": "",
        "name": "onClick",
        "required": false,
        "type": {
          "name": "((event: MouseEvent<Element>) => void) | undefined"
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}